<script>
    import I18n from '@js/modules/translations';

    import Tab from '@js/components/themes/Tab.svelte';

    import RideCard from '@js/components/ride/RideCard.svelte';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    const {
        defaultRideType,
        rides
    } = $props();

    let currentRideTab = $state(defaultRideType);

    const _handleTabChange = (itemId) => {
        currentRideTab = itemId;
    };
</script>

{#snippet rideTypeTab(rideType)}
    <div class:hidden={currentRideTab !== rideType}>
        {#if rides.filter((ride) => ride.rideType === rideType).length > 0}
            <div class="row p-4">
                {#each rides.filter((ride) => ride.rideType === rideType) as ride (ride.id)}
                    <div class="col s12 m6 l4">
                        <RideCard ride={ride}/>
                    </div>
                {/each}
            </div>
        {:else}
            <div class="p-4 italic">
                {I18n.t('js.ride.common.no_rides_type')}
            </div>
        {/if}
    </div>
{/snippet}

<div class="my-8">
    <Tab items={
        Object.keys(RIDE_TYPE_ICON).map((rideType) => ({
            id: rideType,
            title: I18n.t(`js.ride.enums.ride_type.${rideType}`),
            icon: RIDE_TYPE_ICON[rideType]
        }))
    }
         openedTabId={currentRideTab}
         onTabChange={_handleTabChange}/>

    {@render rideTypeTab('running')}
    {@render rideTypeTab('hiking')}
    {@render rideTypeTab('bike')}
    {@render rideTypeTab('walk')}
</div>
